
import { useState, useEffect } from 'react';
import { PhoneOutlined, LinkOutlined } from '@ant-design/icons';

import { useModel } from 'umi';

import { Link } from 'umi';
import './index.css';

import { Button, Drawer, Card } from 'antd';

export default function HomePage() {

    const { config } = useModel('global');  
    const [ drawer, setDrawer ] = useState(false);

    document.title = config?.name;
    return (
        <div
            style={{
                backgroundImage: `url(${config?.bg})`
            }}
            className="houses"
        >

            {config?.houses?.map(house => <div className="house">
                <div className="city">{house?.city}</div>
                <h2>{house?.address}</h2>

                <Button
                    onClick={() => {
                        setDrawer(house);
                    }}  
                >Обслуживающие организации</Button>             
                {(house?.chats?.max !== undefined) && (<Button href={house?.chats?.max} target='_blank'>Официальный чат</Button>)}
                {(house?.chats?.telegram !== undefined) && (<Button href={house?.chats?.telegram} target='_blank'>Чат жальцов</Button>)}
          
            </div>)}
            <Drawer
                open={drawer !== false}
                onClose={() => {
                    setDrawer(false);
                }}
                title={drawer?.address}
            >
                <p>Обслуживающие организации</p>
                {drawer?.services?.map(s => <div className="service">
                    <div className="what">{s.extra}</div>
                    <div className="org">{s.name}</div>
                    <Button.Group>
                        {(s.phone !== undefined) && (<Button icon={<PhoneOutlined />} href={"tel:" + s.phone.replace(/[^\d+]/g, '')}>{s.phone}</Button>)}
                        {(s.website !== undefined) && (<Button icon={<LinkOutlined />} href={s.website} target="_blank"></Button>)}
                    </Button.Group>
                </div>)}

            </Drawer>
        </div>
    );
}
